import { useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import type { GeneratedFile } from '../../../../types/generatedFile';
import { AssetPreviewModal } from '../AssetPreviewModal';

interface GeneratedFilePreviewModalProps {
  file: GeneratedFile | null;
  open: boolean;
  onClose: () => void;
}

const providerLabels: Record<string, string> = {
  outputController: 'Display Box',
  reportBuilder: 'Report Builder',
  commandTextNode: 'AI Text Generator',
};

function GeneratedFilePreviewModal({
  file,
  open,
  onClose,
}: GeneratedFilePreviewModalProps) {
  const [isLoading, setIsLoading] = useState(true);

  if (!open || !file) return null;

  const iframeSrc =
    file.fileType === 'pdf'
      ? file.fileUrl
      : `https://docs.google.com/gview?url=${encodeURIComponent(file.fileUrl)}&embedded=true`;

  return (
    <AssetPreviewModal
      open
      onClose={onClose}
      name={file.name}
      provider={file.provider}
      providerLabels={providerLabels}
      fileType={file.fileType}
      createdAt={file.createdAt}
      assetUrl={file.fileUrl}
      downloadFileName={file.name || `generated-file.${file.fileType}`}
      fullscreenEnabled
      maxWidth='md'
      contentMinHeight='400px'
      renderContent={({ isFullscreen }) => (
        <>
          {isLoading && (
            <CircularProgress size={32} sx={{ position: 'absolute' }} />
          )}
          <Box
            component='iframe'
            src={iframeSrc}
            onLoad={() => setIsLoading(false)}
            sx={{
              width: '100%',
              height: isFullscreen ? 'calc(100vh - 160px)' : '70vh',
              border: 'none',
              borderRadius: '8px',
              opacity: isLoading ? 0 : 1,
              transition: 'opacity 0.3s ease',
            }}
          />
        </>
      )}
    />
  );
}

export { GeneratedFilePreviewModal };
